import * as React from 'react';
import 'react-dates/initialize';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';
import { theme } from '../../theme';

type State = {
  focusedInput: any;
  startDate: any;
  endDate: any;
};

type Props = {
  onDatesChange: (dates: { startDate: any; endDate: any }) => any;
  startDate: any;
  endDate: any;
  startDateId: string;
  endDateId: string;
};

const DatePickerWrapper = styled.div`
  width: 100%;
  .DateInput {
    display: flex;
    height: 40px;
    border-radius: 5px;
    width: 100%;
  }
  .DateInput_input {
    display: flex;
    border-radius: 5px;
    font-weight: 400;
    border-radius: 4px;
    border: none;
    color: ${themeGet('colors.coal', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
    font-family: ${themeGet('fontFamily')};
    font-style: normal;
    min-width: 100px;
    &:disabled {
      opacity: 0.5;
    }
  }
  .DateRangePicker {
    border-radius: 5px;
    display: flex;
    width: 300px;
  }
  .DateRangePickerInput_arrow {
    margin: 0 5px;
    align-items: center;
    justify-content: center;
    display: flex;
  }
  .DateRangePicker_picker {
    z-index: ${theme.zIndex[6]};
  }
  .DateRangePicker > div,
  .DateRangePicker > div > .DateRangePickerInput {
    display: flex;
  }
  .DateRangePickerInput__withBorder {
    border: 1px solid rgba(50, 50, 93, 0.2);
    border-radius: 5px;
    height: 40px;
  }
  .CalendarMonth_caption {
    padding-top: 16px;
  }
`;

class StyledDateRangePicker extends React.Component<Props, State> {
  state = {
    focusedInput: null,
    startDate: this.props.startDate,
    endDate: this.props.endDate,
  };

  render() {
    const { startDate, endDate, startDateId, endDateId, onDatesChange } = this.props;

    return (
      <DatePickerWrapper>
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onDatesChange={onDatesChange}
          focusedInput={this.state.focusedInput}
          onFocusChange={(focusedInput) => this.setState({ focusedInput })}
          startDateId={startDateId}
          endDateId={endDateId}
          isOutsideRange={() => false}
          displayFormat="DD/MM/YYYY"
          minimumNights={0}
          enableOutsideDays={true}
          keepOpenOnDateSelect={false}
        />
      </DatePickerWrapper>
    );
  }
}

export default StyledDateRangePicker;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledDateRangePicker.tsx